export default __webpack_public_path__ + "static/media/product-banner4.716fe3e7.png";